import { useState } from "react";
import { toast } from "react-toastify";
import { deleteClasses } from "../../../service/classes";
import { RoomService, AssignedRoom } from "../../../service/class-room";

interface DeleteClassModalProps {
  selectedId?: string | null;
  setSelectedId?: (id: string | null) => void;
  fetchData?: () => void;
  appliedFilters?: { system?: string } | null;
  isClassStyleSystem?: boolean;
  allClasses?: any[];
  assignedRooms?: AssignedRoom[];
   availableRooms?: () => void;
}

const DeleteModal = ({
  selectedId,
  setSelectedId,
  fetchData,
  appliedFilters,
  isClassStyleSystem = true,
  allClasses = [],
  assignedRooms = [],
  availableRooms,
}: DeleteClassModalProps) => {
  const [isDeleting, setIsDeleting] = useState(false);

const handleDelete = async (e: React.MouseEvent) => {
  e.preventDefault();
  if (!selectedId || isDeleting) return;

    try {
      setIsDeleting(true);
      const classToDelete = allClasses.find(cls => cls._id === selectedId);
      
      if (!classToDelete) {
        toast.error("Class not found!");
        return;
      }
      const classRoomAssignments = assignedRooms.filter((ar) => {
        return ar.section.class && ar.section.class._id === selectedId && ar.isActive;
      });
      const sectionIds = classToDelete.sections.map((s: any) => s._id);
      
      const assignmentsBySectionIds = assignedRooms.filter((ar) => {
        return sectionIds.includes(ar.section._id) && ar.isActive;
      });
      const assignmentsToDelete = classRoomAssignments.length > 0 
        ? classRoomAssignments 
        : assignmentsBySectionIds;
      if (assignmentsToDelete.length > 0) {
        const deletePromises = assignmentsToDelete.map(async (assignment) => {
          try {
            if (!assignment.assignmentId && !assignment._id) {
              return { 
                success: false, 
                section: assignment.section.name, 
                error: "Missing assignment ID" 
              };
            }
            const assignmentIdToDelete = assignment.assignmentId || assignment._id;
            
            if (!assignmentIdToDelete) {
              return { 
                success: false, 
                section: assignment.section.name, 
                error: "No valid assignment ID found" 
              };
            }
            await RoomService.deleteRoomAssignment(assignmentIdToDelete);
            return { success: true, section: assignment.section.name };
          } catch (err) {
            return { success: false, section: assignment.section.name, error: err };
          }
        });
        
        const results = await Promise.all(deletePromises);
        const successful = results.filter(r => r.success).length;
        const failed = results.filter(r => !r.success).length;
      } else {
      }
      await deleteClasses(selectedId);
       
        toast.success(`Class deleted successfully`);
      
      setSelectedId?.(null);
        if (fetchData) {
        await fetchData();
      }
      
      if (availableRooms) {
        await availableRooms();
      }
    } catch (error: any) {
      toast.error(error.response?.data?.message || "Failed to delete class");
    } finally {
      setIsDeleting(false);
    }
};

  return (
    <div className="modal fade" id="delete-modal">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body text-center">
            <span className="delete-icon">
              <i className="ti ti-trash-x" />
            </span>
            <h4>Confirm Deletion</h4>
            <p>
              Are you sure you want to delete this{" "}
              {isClassStyleSystem ? "class?" : "grade?"}{" "}
              This action cannot be undone.
            </p>

            <div className="d-flex justify-content-center">
              <button className="btn btn-light me-3" data-bs-dismiss="modal">
                Cancel
              </button>
              <button
                className="btn btn-danger"
                onClick={handleDelete}
                disabled={isDeleting}
                data-bs-dismiss="modal"
              >
                {isDeleting ? "Deleting..." : "Yes, Delete"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;